export default __webpack_public_path__ + "static/media/scrolltofind.e6183657.svg";